import { useEffect, useState } from 'react';

import { ANNOUNCE_EVENT, AnnouncePoliteness } from '../../../utils/announce';
import { addEventListener, removeEventListener } from '../../../utils/event-emitter';

const LiveAnnouncer = (): JSX.Element => {
	const [politeMessage, setPoliteMessage] = useState('');
	const [assertiveMessage, setAssertiveMessage] = useState('');

	useEffect(() => {
		const setters = { polite: setPoliteMessage, assertive: setAssertiveMessage };
		const timeouts: Partial<Record<AnnouncePoliteness, number>> = {};

		// cleared first so a repeated message is still announced
		const handleAnnounce = (text: string, politeness: AnnouncePoliteness) => {
			const setMessage = setters[politeness];
			setMessage('');
			window.clearTimeout(timeouts[politeness]);
			timeouts[politeness] = window.setTimeout(() => {
				setMessage(text);
			}, 100);
		};

		addEventListener(ANNOUNCE_EVENT, handleAnnounce);

		return () => {
			removeEventListener(ANNOUNCE_EVENT, handleAnnounce);
			window.clearTimeout(timeouts.polite);
			window.clearTimeout(timeouts.assertive);
		};
	}, []);

	return (
		<>
			<div role="status" aria-live="polite" aria-atomic="true" className="visually-hidden">
				{politeMessage}
			</div>
			<div aria-live="assertive" aria-atomic="true" className="visually-hidden">
				{assertiveMessage}
			</div>
		</>
	);
};

export default LiveAnnouncer;
